import { MUTATIONS } from '../../constants/sort';

export const mutations = {
  [MUTATIONS.UPDATE_FILTER](state, key) {
    state.sortKey = key;
  }
};
